'use strict';

goog.provide('Ntry.AiEngineView');

Ntry.AiEngineView = function() {
    this._view = Ntry.interfaceManager.getDom('ntryEngine');
    this._ratio = 0;
    this._sliderWidth = 88;
    this._data = {
        left: { type: -1 },
        center: { type: -1 },
        right: { type: -1 },
    };
    this._inited = false;

    this._mode = Entry.Workspace.MODE_BOARD;

    this._itemTypes = {
        1: 'destination',
        2: 'asteroids',
        3: 'item',
        4: 'item',
        5: 'wall',
    };

    this._backupKnobPosition = 0;

    Ntry.addEventListener('run', this, this.viewModeRun);
    Ntry.addEventListener('run', this, this.backupSlider);
    Ntry.addEventListener('stop', this, this.viewModeStop);
    Ntry.addEventListener('replay', this, this.viewModeReplay);
    Ntry.addEventListener('restoreEnd', this, this.restoreSlider);
    Ntry.addEventListener('textError', this, this.textError);

    this.createDom();

    Ntry.addEventListener('moveAiSlider', this, this.moveAiSlider);
    Ntry.addEventListener('workspaceChangeMode', this, this.setMode);
};

(function(p) {
    p.loadConfig = function() {
        this.isScroll = Ntry.configManager.getConfig('mapper') ? false : true;
        if (!this.isScroll) this._sliderView.addClass('entryHide');
        if (!this._inited && Entry.getMainWS()) {
            this._inited = true;
            Entry.getMainWS().changeEvent.attach(this, this.setMode);
        }
    };

    p.createDom = function() {
        var parent = Ntry.createElement(
            'div',
            this._view,
            null,
            'aiEngineSection',
            'selectDisable'
        );

        var leftSection = Ntry.createElement('div', parent, null, 'aiEngineLeftSection');
        this.createSlider(leftSection);

        this._engineButton = Ntry.createElement('button', leftSection, 'aiEngineButton', 'stopped');
        this._engineButton.innerHTML = Lang.Workspace.run;

        var rightSection = Ntry.createElement('div', parent, null, 'aiEngineRightSection');

        var distance1 = Ntry.createElement('div', rightSection, null, 'aiEngineInfoContainer');
        var distance1_sub = Ntry.createElement(
            'span',
            distance1,
            null,
            'aiEngineInfoContainer_sub'
        );
        this._distance1_sub = distance1_sub;
        distance1_sub.innerHTML = Lang.Menus.above_radar;
        this._distanceUp = Ntry.createElement('span', distance1, null, 'aiEngineInfo');

        var name1 = Ntry.createElement(
            'div',
            rightSection,
            null,
            'aiEngineInfoContainer',
            'aiEngineInfoContainerBig'
        );
        var name1_sub = Ntry.createElement('span', name1, null, 'aiEngineInfoContainer_sub');
        name1_sub.innerHTML = Lang.Menus.above_object;
        this._nameUp = Ntry.createElement('span', name1, null, 'aiEngineInfo', 'aiEngineInfoBig');
        this._name1_sub = name1_sub;

        var distance3 = Ntry.createElement('div', rightSection, null, 'aiEngineInfoContainer');
        var distance3_sub = Ntry.createElement(
            'span',
            distance3,
            null,
            'aiEngineInfoContainer_sub'
        );
        distance3_sub.innerHTML = Lang.Menus.front_radar;
        this._distanceRight = Ntry.createElement('span', distance3, null, 'aiEngineInfo');
        this._distance3_sub = distance3_sub;

        var name3 = Ntry.createElement(
            'div',
            rightSection,
            null,
            'aiEngineInfoContainer',
            'aiEngineInfoContainerBig'
        );
        var name3_sub = Ntry.createElement('span', name3, null, 'aiEngineInfoContainer_sub');
        name3_sub.innerHTML = Lang.Menus.front_object;
        this._nameRight = Ntry.createElement(
            'span',
            name3,
            null,
            'aiEngineInfo',
            'aiEngineInfoBig'
        );
        this._name3_sub = name3_sub;

        var distance2 = Ntry.createElement('div', rightSection, null, 'aiEngineInfoContainer');
        var distance2_sub = Ntry.createElement(
            'span',
            distance2,
            null,
            'aiEngineInfoContainer_sub'
        );
        distance2_sub.innerHTML = Lang.Menus.bottom_radar;
        this._distanceDown = Ntry.createElement('span', distance2, null, 'aiEngineInfo');
        this._distance2_sub = distance2_sub;

        var name2 = Ntry.createElement(
            'div',
            rightSection,
            null,
            'aiEngineInfoContainer',
            'aiEngineInfoContainerBig'
        );
        var name2_sub = Ntry.createElement('span', name2, null, 'aiEngineInfoContainer_sub');
        name2_sub.innerHTML = Lang.Menus.below_object;
        this._nameDown = Ntry.createElement('span', name2, null, 'aiEngineInfo', 'aiEngineInfoBig');
        this._name2_sub = name2_sub;

        this._engineButton.bindOnClick(function(e) {
            e.preventDefault();
            this.blur();
            Ntry.dispatchEvent('engineButtonClicked');
        });
    };

    p.createSlider = function(leftSection) {
        var that = this;
        var handler = Ntry.createElement('div', leftSection, null, 'aiEngineHandlerContainer');
        this._sliderView = handler;

        var leftHandle = Ntry.createElement('span', handler, null, 'aiEngineHandlerLeft');
        leftHandle.bindOnClick(function() {
            Ntry.dispatchEvent('moveAiSlider', that._knob, -5);
        });

        var slider = Ntry.createElement('div', handler, null, 'aiEngineSlider');
        var knob = (this._knob = Ntry.createElement('div', slider, null, 'aiEngineSliderKnob'));

        var rightHandle = Ntry.createElement('span', handler, null, 'aiEngineHandlerRight');
        rightHandle.bindOnClick(function() {
            Ntry.dispatchEvent('moveAiSlider', that._knob, 5);
        });

        var isFontSizing = false;
        var resizeOffset = 0;
        this._knob.onmousedown = function(e) {
            isFontSizing = true;
            resizeOffset = $(slider).offset().left;
        };

        this._knob.addEventListener('touchstart', function() {
            isFontSizing = true;
            resizeOffset = $(slider).offset().left;
        });

        document.addEventListener('mousemove', function(e) {
            if (isFontSizing) {
                var left = e.pageX - resizeOffset;
                that.setLeftPos(left);
            }
        });

        document.addEventListener('touchmove', function(e) {
            if (isFontSizing) {
                var left = e.touches[0].pageX - resizeOffset;
                that.setLeftPos(left);
            }
        });

        document.addEventListener('mouseup', function(e) {
            isFontSizing = false;
        });

        document.addEventListener('touchend', function(e) {
            isFontSizing = false;
        });
    };

    p.setLeftPos = function(left, knob) {
        left = Math.max(left, 5);
        left = Math.min(left, 88);
        this.setRatio(left);
        this._knob.style.left = left + 'px';
        left /= 0.88;
    };

    p.moveAiSlider = function(knob, delta) {
        kbob = knob || this._knob;
        knob = $(knob);
        var leftPosition = knob.css('left') == 'auto' ? '5px' : knob.css('left');
        leftPosition = Number(leftPosition.substring(0, leftPosition.length - 2));

        leftPosition += delta;
        this.setRatio(leftPosition);
    };

    p.getRatio = function() {
        return this._ratio;
    };

    p.setRatio = function(left) {
        var knob = $(this._knob);
        left = Math.max(left, 5);
        left = Math.min(left, 88);
        this._ratio = (left - 5) / (this._sliderWidth - 5);

        knob.css('left', left);
        Ntry.dispatchEvent('engineSliderMove', this.getRatio());
    };

    p.viewModeRun = function() {
        var button = this.getPureButton();
        button.addClass('running');
        button.innerHTML = Lang.Menus.engine_running;

        if (window.cpartyuserkey) {
            var script = Blockly.Xml.workspaceToDom(Blockly.mainWorkspace);
            var userScript = Blockly.Xml.domToText(script);
            var activity = new Entry.Activity('run', [['script', userScript]]);
            Entry.activityReporter.add(activity);
            Ntry.dispatchEvent('saveLogs');
        }
    };

    p.backupSlider = function() {
        //if (this._isBackuping)
        //return;
        //var that = this;
        //this._isBackuping =true;
        //var ratio = this.getRatio();
        //var knob = this._knob;
        //var left = this._backupKnobPosition = $(knob).css('left');
        //if (isNaN(left))
        //this._backupKnobPosition = left = left.substring(0, left.length-2);
        //$(knob).animate({
        //'left': '5'
        //}, 200, function(){
        //that._isBackuping = false;
        //});
        var knob = $(this._knob);
        var left = (this._backupKnobPosition = knob.css('left'));
        if (isNaN(left)) this._backupKnobPosition = left = left.substring(0, left.length - 2);

        knob.css('left', '5px');
    };

    p.restoreSlider = function() {
        this.setRatio(this._backupKnobPosition);
    };

    p.viewModeStop = function() {
        var button = this.getPureButton();
        button.addClass('stopped');
        button.innerHTML = Lang.Workspace.run;
    };

    p.viewModeReplay = function() {
        var button = this.getPureButton();
        button.addClass('end');
        button.innerHTML = Lang.Menus.engine_replay;
    };

    p.getPureButton = function() {
        this._engineButton.removeClasses();
        return this._engineButton;
    };

    p.update = function(isForce) {
        var em = Ntry.entityManager;
        var entity = em.getEntitiesByComponent(Ntry.STATIC.SCRIPT_CONTAINER);

        if (_.isEmpty(entity)) entity = em.getEntitiesByComponent(Ntry.STATIC.CODE);

        component = em.getComponent(_.first(_.keys(entity)), Ntry.STATIC.RADAR);
        if (!component) return;
        var left = component.left;
        var center = component.center;
        var right = component.right;

        var originData = this._data;

        if (_.isEmpty(originData.left) || left.distance != originData.left.distance) {
            originData.left.distance = left.distance;
            this._distanceUp.innerHTML = left.distance;
        }

        if (_.isEmpty(originData.right) || right.distance != originData.right.distance) {
            originData.right.distance = right.distance;
            this._distanceDown.innerHTML = right.distance;
        }

        if (_.isEmpty(originData.center) || center.distance != originData.center.distance) {
            originData.center.distance = center.distance;
            this._distanceRight.innerHTML = center.distance;
        }

        if (isForce || _.isEmpty(originData.left) || left.type != originData.left.type) {
            originData.left.type = left.type;
            var type = left.type;
            this._nameUp.innerHTML = this._getTargetLang(type);
        }

        if (isForce || _.isEmpty(originData.right) || right.type != originData.right.type) {
            originData.right.type = right.type;
            var type = right.type;
            this._nameDown.innerHTML = this._getTargetLang(type);
        }

        if (isForce || _.isEmpty(originData.center) || center.type != originData.center.type) {
            originData.center.type = center.type;
            var type = center.type;
            this._nameRight.innerHTML = this._getTargetLang(type);
        }
    };

    p.setMode = function(mode) {
        mode = mode === undefined ? Entry.getMainWS().getMode() : mode;
        this._mode = mode;

        this._updateLang();
        this.update(true);
    };

    p._updateLang = function() {
        var targets = [
            ['distance1', 'above_radar'],
            ['distance2', 'bottom_radar'],
            ['distance3', 'front_radar'],
            ['name1', 'above_object'],
            ['name2', 'below_object'],
            ['name3', 'front_object'],
        ];

        var base = '_$(key)_sub';
        var mode = this._mode;

        targets.forEach(
            function(target) {
                this[base.replace('$(key)', target[0])].innerHTML = this._getTargetLang(target[1]);
            }.bind(this)
        );
    };

    p.textError = function(mode) {
        this._mode = mode.boardType;
        Ntry.dispatchEvent('stop');
        Ntry.dispatchEvent('engineStop');
    };

    p._getTargetLang = function(type) {
        var mode = this._mode;
        if (!isNaN(type)) type = this._itemTypes[type];
        if (isVim()) type += '_text_mode';
        return Lang.Menus[type];

        function isVim() {
            return mode === Entry.Workspace.MODE_VIMBOARD;
        }
    };
})(Ntry.AiEngineView.prototype);
